<template>
    <div
      class="select-card d-flex flex-column"
      style="margin-bottom: 10px !important;"
      :class="{'border-danger' : errorValidation}"
    >
      <!-- Tile Title -->
      <h3
        class="page-title text-center pt-2"
      >
        {{ $t('transaction_info.title') }}
      </h3>
  
      <!-- Optional Text -->
      <div class="flex-grow-1 d-flex">
        <p
          class="page-text text-left my-2 mx-2"
        >
          <slot name="text"></slot>
        </p>
      </div>

      <!-- Transaction Info -->
      <TransactionInfo
        v-if="result"
        :result="result"
        :showTransactionRating="false"
      />

      <div
        class="text-center my-3"
      >
        <span v-text="$t('transaction_info.history_link')" />
        <span>
          <router-link to="/history">
            {{ $t('home.take.history') }}
          </router-link>
        </span>
        
      </div>
  
      <!-- Action Buttons -->
      <div
        class="tile-actions d-flex justify-content-end"
        :class="{ 'mb-4': errorValidation }"
      >
        <BButton
          class="button my-2"
          variant="primary"
          @click="confirmAction"
          v-text="$t('transaction_info.close')"
        />
      </div>
      <BRow v-if="errorValidation">
        <BCol>
          <div class="message-fail">
            <h5>{{ messageErrorValidation }}</h5>
          </div>
        </BCol>
      </BRow>
    </div>
  </template>
  
  <script>
  import '@/main.scss'
  import TransactionInfo from '@/components/TransactionInfo.vue'
  
  export default {
    name: 'LastTransactionInfo',
    components: {
      TransactionInfo
    },
    props: {
      classification: {
        type: Boolean,
        default: true
      },
      result: {
        type: Object,
        default: null
      }
    },
    mounted() {
      console.log(this.result);
      
    },
    data: function () {
      return {
        checkBoxInitValue: false,
        errorValidation: false,
        messageErrorValidation: '',
        rating: 0
      }
    },
    methods: {
      confirmAction() {
        this.$emit('confirmAction')
      }
    }
  }
  </script>
  
  <style scoped>
  @import '../main.scss';
  
  .tile-actions {
    display: flex;
    justify-content: center;
    gap: 1rem;
  }
  
  .flex-grow-1 {
    flex-grow: 1;
    display: flex;
    align-items: left;
    justify-content: center;
  }
  
  .page-text {
    text-align: justify;
    margin: 0;
    max-width: 90%;
  }
  
  #loading-spinner {
    display: block;
    color: #f58a48;
  }
  
  .message-fail {
    width: 100%;
    padding: 0.2rem 1rem;
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: left;
    line-height: 1;
    box-sizing: border-box;
    margin-top: 0.5rem;
    max-height: 2rem;
    overflow: hidden;
    font-size: 16px;
    font-weight: bold;
    color: white;
    background-color: red;
  }
  

  </style>
  